import React, { useState } from 'react';
import StaffLogin from './StaffLogin';
import StaffConsole from './StaffConsole';
import SpecialistConsole from './SpecialistConsole';

/**
 * StaffAdmin - Wrapper to manage Login -> Console transition
 */
const StaffAdmin = ({ ipserv }) => {
    // Initial state from localStorage to persist session on refresh
    const [auth, setAuth] = useState(() => {
        const saved = localStorage.getItem('turnero_staff_session');
        return saved ? JSON.parse(saved) : {
            isLoggedIn: false,
            user: null,
            typeId: null,
            sucursalId: null,
            specialistId: null
        };
    });

    const handleLoginSuccess = (user) => {
        const newAuth = {
            isLoggedIn: true,
            user,
            typeId: user.TipoAsociado,
            sucursalId: user.SucursalId,
            specialistId: user.EspecialistaId // Viene del backend si está vinculado
        };
        setAuth(newAuth);
        localStorage.setItem('turnero_staff_session', JSON.stringify(newAuth));
    };

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    };

    if (!auth.isLoggedIn) {
        return <StaffLogin ipserv={ipserv} onLoginSuccess={handleLoginSuccess} />;
    }

    // Si es Especialista, mostramos su consola dedicada
    if (auth.specialistId) {
        return (
            <SpecialistConsole 
                ipserv={ipserv} 
                specialistId={auth.specialistId} 
                onLogout={handleLogout} 
            />
        );
    }

    // Si es Staff normal, consola tradicional
    return (
        <StaffConsole 
            ipserv={ipserv} 
            user={auth.user} 
            typeId={auth.typeId} 
            sucursalId={auth.sucursalId}
            onLogout={handleLogout}
        />
    );
};

export default StaffAdmin;
